import TASC from "components/Stacker/constants/TypeAheadSearchConstants"

const baseStructure = {
  suggestions: {
    contentList: [],
    productList: [],
  },
  selected: {
    index: -1,
    suggestion: "",
    type: "",
  },
  searchTerm: "",
  istypeAheadEnabled: false,
}

const initialState = {}

export default function searchSuggestions(
  previousState = initialState,
  action
) {
  //	let searchTerm = '';
  let newObj
  switch (action.type) {
    case TASC.GET_SEARCH_SUGGESTIONS_SUCCESS:
      return {
        ...previousState,
        [action.payload.formName]: {
          ...previousState[action.payload.formName],
          suggestions: action.payload.resp,
        },
      }
    case TASC.RESET_SEARCH_SUGGESTIONS:
      // if (previousState.selected.type !== '') {
      // 	searchTerm =
      // 		typeof previousState.selected.suggestion === 'object'
      // 			? previousState.selected.suggestion.title
      // 			: previousState.selected.suggestion;
      // } else {
      // 	({ searchTerm } = previousState);
      // }

      return {
        ...previousState,
        [action.payload.formName]: {
          ...previousState[action.payload.formName],
          suggestions: action.payload.suggestions,
          selected: {
            index: -1,
            suggestion: "",
            type: "",
          },
          searchTerm: "",
        },
      }
    case TASC.SET_SELECTED_SUGGESTION:
      return {
        ...previousState,
        [action.payload.formName]: {
          ...previousState[action.payload.formName],
          selected: action.payload.selected,
        },
      }
    case TASC.SET_SEARCH_TERM:
      return {
        ...previousState,
        [action.payload.formName]: {
          ...previousState[action.payload.formName],
          selected: {
            index: -1,
            suggestion: action.payload.searchTerm,
            type: "",
          },
          searchTerm: action.payload.searchTerm,
          istypeAheadEnabled: true,
        },
      }
    case TASC.GET_SEARCH_SUGGESTIONS_FAILURE:
      return {
        ...previousState,
        [action.payload.formName]: {
          ...previousState[action.payload.formName],
          suggestions: {
            contentList: [],
            productList: [],
          },
        },
      }
    case TASC.SET_INITIAL_STATE:
      return {
        ...previousState,
        [action.payload]: { ...baseStructure },
      }
    case TASC.TYPEAHEAD_DESTROY:
      newObj = {
        ...previousState,
      }
      delete newObj[action.payload]
      return newObj
    case TASC.TYPEAHEAD_TOGGLE:
      return {
        ...previousState,
        [action.payload.formName]: {
          ...previousState[action.payload.formName],
          istypeAheadEnabled: action.payload.toggleState,
        },
      }
    default:
      return previousState
  }
}
